import { useMutation } from "@apollo/client";

import {
  ManagedUserGroupIntegration,
  ManagedUserGroupIntegrationCreateInput,
} from "types/generated";

import { CREATE_MANAGED_USER_GROUP_INTEGRATION } from "../../gql";

const useCreateIntegration = () => {
  const [createManagedUserGroupIntegration] = useMutation<{
    managedUserGroupIntegrationCreate: ManagedUserGroupIntegration;
  }>(CREATE_MANAGED_USER_GROUP_INTEGRATION, {
    refetchQueries: ["GetManagedUserGroupIntegrations"],
  });

  const onCreate = (input: ManagedUserGroupIntegrationCreateInput) => {
    return createManagedUserGroupIntegration({
      variables: {
        input,
      },
    });
  };

  return { onCreate };
};

export default useCreateIntegration;
